import { render, staticRenderFns } from "./indexBookModule.vue?vue&type=template&id=1a2edffc&scoped=true"
import script from "./indexBookModule.vue?vue&type=script&lang=js"
export * from "./indexBookModule.vue?vue&type=script&lang=js"
import style0 from "./indexBookModule.vue?vue&type=style&index=0&id=1a2edffc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2edffc",
  null
  
)

export default component.exports